import { EventTriggerNames, PlatformName } from './types/new-types';

type EventsNamesMap = Record<EventTriggerNames, string>;
type PlatformNamesMap = Record<PlatformName, EventsNamesMap>;

const gtmEventsMap: EventsNamesMap = {
  user_data: 'user_data',
  login: 'login',
  sign_up: 'sign_up',
  sign_up_v2: 'sign_up_v2',
  click_generation_start: 'click_generation_start',
  style_change_save: 'style_change_save',
  generation_slide_start: 'generation_slide_start',
  generation_slide_done: 'generation_slide_done',
  generation_add_slide: 'generation_add_slide',
  generation_delete_slide: 'generation_delete_slide',
  generation_duplicate_slide: 'generation_duplicate_slide',
  generation_move_slide: 'generation_move_slide',
  design_editing: 'design_editing',
  design_editing_canvas: 'design_editing',
  file_rename: 'file_rename',
  trial_popup_close: 'trial_popup_close',
  file_delete: 'file_delete',
  click_file_download: 'click_file_download',
  file_create_duplicate: 'file_create_duplicate',
  trial_popup_to_checkout: 'trial_popup_to_checkout',
  share: 'share',
  file_download: 'file_download',
  onboarding_submit: 'onboarding_submit',
  payment_refuse_survey_close: 'payment_refuse_survey_close',
  payment_refuse_survey_to_checkout: 'payment_refuse_survey_to_checkout',
  payment_refuse_survey_answer: 'payment_refuse_survey_answer',
  service_error_system: 'service_error_system',
  service_error_preview: 'service_error_preview',
  generation_start: 'generation_start',
  generation_first_slide_done: 'generation_first_slide_done',
  generation_done: 'generation_done',
  slideshow_started: 'slideshow_started',
  begin_checkout: 'begin_checkout',
  chat_submit: 'chat_submit',
  cards_submit: 'cards_submit',
  click_plan: 'click_plan',
  click_upgrade_to_pro: 'click_upgrade_to_pro',
  click_new_version_banner: 'click_new_version_banner',
  dismiss_new_version_banner: 'dismiss_new_version_banner',
};

export const platformsEventsNameMap: PlatformNamesMap = {
  [PlatformName.GTM]: gtmEventsMap,
};
